import { IconSize } from '../c-icon/enum/icon-size.enum'
import { IconType } from '../c-icon/enum/icon-type.enum'
import { Checkbox } from './checkbox'

/**
 * Defines the properties of a checkbox
 */
export class CheckboxFactory {
  static newCheckbox(props: Checkbox): Checkbox {
    return new Checkbox(props)
  }

  /**
   * Creates a checkbox used to Notification enabling/disabling.
   * @param props Optional props, allowing checkbox overrides.
   * @returns
   */
  static notificationsCheckbox(props?: Checkbox): Checkbox {
    const notificationsCheckbox = CheckboxFactory.newCheckbox({
      iconDisabled: { icon: 'bell-slash' },
      iconEnabled: { icon: 'bell-on' },
      name: 'Notifications',
      label: 'Enable notifications',
      iconEnabledColor: 'color-blue-dark1',
      textEnabledColor: 'color-blue-dark1',
      iconDisabledColor: 'color-shades-medium1',
      textDisabledColor: 'color-text-medium1',
      required: false,
      ...props
    })
    return notificationsCheckbox
  }
  static defaultCheckbox(props?: Checkbox): Checkbox {
    const defaultCheckbox = CheckboxFactory.newCheckbox({
      iconDisabled: { icon: 'square', type: IconType.regular, size: IconSize.large },
      iconEnabled: { icon: 'square-check', size: IconSize.large },
      name: '',
      label: '',
      iconEnabledColor: 'color-text-base',
      textEnabledColor: 'color-text-base',
      iconDisabledColor: 'color-text-base',
      textDisabledColor: 'color-text-base',
      required: true,
      ...props
    })
    return defaultCheckbox
  }
}
